interface ISvgArrowProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgArrow: React.FC<ISvgArrowProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.25002 16.25H20.2125L14.1125 22.35C13.625 22.8375 13.625 23.6375 14.1125 24.125C14.6 24.6125 15.3875 24.6125 15.875 24.125L24.1125 15.8875C24.6 15.4 24.6 14.6125 24.1125 14.125L15.875 5.88747C15.3875 5.39997 14.6 5.39997 14.1125 5.88747C13.625 6.37498 13.625 7.16248 14.1125 7.64998L20.2125 13.75L6.25002 13.75C5.56252 13.75 5.00002 14.3125 5.00002 15C5.00002 15.6875 5.56252 16.25 6.25002 16.25Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgArrow;
